import WalletAddress from './WalletAddress';

export { ButtonType } from './types';
export default WalletAddress;